package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolUsersAnalyticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    val metrics: SchoolUsersAnalyticsMetrics = SchoolUsersAnalyticsMetrics()
)

@Serializable
data class SchoolUsersAnalyticsMetrics(
    @SerialName("total_users")
    val totalUsers: Int = 0,
    @SerialName("active_users")
    val activeUsers: Int = 0,
    @SerialName("inactive_users")
    val inactiveUsers: Int = 0
)
